var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "business-manager-wrap" },
    [
      _c("img", {
        staticClass: "kefu",
        attrs: { src: require("@/assets/images/kefu.png") },
        on: { click: _vm.toggleDialog },
      }),
      _c(
        "div",
        {
          class: {
            dialog: true,
            show: _vm.dialogShow,
            "ticket-only": !_vm.nickName,
          },
        },
        [
          _c("div", { staticClass: "close", on: { click: _vm.toggleDialog } }, [
            _c("p"),
          ]),
          _vm.nickName
            ? _c(
                "div",
                { staticClass: "avatar" },
                [
                  _vm.avatar
                    ? _c(
                        "b-img",
                        _vm._b(
                          { attrs: { alt: "Circle image", src: _vm.avatar } },
                          "b-img",
                          _vm.mainProps,
                          false
                        )
                      )
                    : _c("img", {
                        staticClass: "defalut-manager",
                        attrs: {
                          src: require("@/assets/images/default_manager.png"),
                        },
                      }),
                  _c("div", { staticClass: "right" }, [
                    _c("h3", [_vm._v(_vm._s(_vm.nickName))]),
                    _c("p", [_vm._v("Account Manager")]),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm.nickName
            ? _c("div", { staticClass: "detail" }, [
                _vm.businessDetail.phone
                  ? _c("p", [
                      _vm._m(0),
                      _c("span", [_vm._v(_vm._s(_vm.businessDetail.phone))]),
                    ])
                  : _vm._e(),
                _vm.businessDetail.email
                  ? _c("p", [
                      _vm._m(1),
                      _c("span", [_vm._v(_vm._s(_vm.businessDetail.email))]),
                    ])
                  : _vm._e(),
                _vm.businessDetail.whatsapp
                  ? _c("p", [
                      _vm._m(2),
                      _c("span", [_vm._v(_vm._s(_vm.businessDetail.whatsapp))]),
                    ])
                  : _vm._e(),
                _vm.businessDetail.wechat
                  ? _c("p", [
                      _vm._m(3),
                      _c("span", [_vm._v(_vm._s(_vm.businessDetail.wechat))]),
                    ])
                  : _vm._e(),
                _vm.businessDetail.skype
                  ? _c("p", [
                      _vm._m(4),
                      _c("span", [_vm._v(_vm._s(_vm.businessDetail.skype))]),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "ticket-action" },
            [
              _c("p", { staticClass: "ticket-intro" }, [
                _c("strong", [
                  _vm._v(_vm._s(_vm.$t("ticket.intro").split("\n")[0])),
                ]),
                _c("br"),
                _vm._v(
                  _vm._s(_vm.$t("ticket.intro").split("\n").slice(1).join("\n"))
                ),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.ticketForm.open()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("ticket.title")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c("ticket-form", { ref: "ticketForm" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _c("img", { attrs: { src: require("@/assets/images/phone.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _c("img", { attrs: { src: require("@/assets/images/email.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _c("img", { attrs: { src: require("@/assets/images/whats.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _c("img", { attrs: { src: require("@/assets/images/wechat.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _c("img", { attrs: { src: require("@/assets/images/skype.png") } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }